import {pick,find} from 'lodash';

// Stolen from AOD
// todo - pull this from the server


export const webAdSizes = [
    {
        "id" : 26,
        "name" : "Custom",
        "label" : "AdSize.Custom.label",
        "longLabel" : "AdSize.Custom.longLabel.label",
        "title" : "AdSize.Custom.title.label",
        "width" : 0.0,
        "height" : 0.0,
        "maxFileSize" : -1
    },
    {
    "id" : 8,
    "name" : "300x250 (Medium Rectangle)",
    "label" : "AdSize.300x250 (Medium Rectangle).label",
    "longLabel" : "AdSize.300x250 (Medium Rectangle).longLabel.label",
    "title" : "AdSize.300x250 (Medium Rectangle).title.label",
    "width" : 300.0,
    "height" : 250.0,
    "maxFileSize" : -1
}, {
    "id" : 9,
    "name" : "250x250 (Square Pop-up)",
    "label" : "AdSize.250x250 (Square Pop-up).label",
    "longLabel" : "AdSize.250x250 (Square Pop-up).longLabel.label",
    "title" : "AdSize.250x250 (Square Pop-up).title.label",
    "width" : 250.0,
    "height" : 250.0,
    "maxFileSize" : -1
}, {
    "id" : 10,
    "name" : "240x400 (Vertical Rectangle)",
    "label" : "AdSize.240x400 (Vertical Rectangle).label",
    "longLabel" : "AdSize.240x400 (Vertical Rectangle).longLabel.label",
    "title" : "AdSize.240x400 (Vertical Rectangle).title.label",
    "width" : 240.0,
    "height" : 400.0,
    "maxFileSize" : -1
}, {
    "id" : 11,
    "name" : "336x280 (Large Rectangle)",
    "label" : "AdSize.336x280 (Large Rectangle).label",
    "longLabel" : "AdSize.336x280 (Large Rectangle).longLabel.label",
    "title" : "AdSize.336x280 (Large Rectangle).title.label",
    "width" : 336.0,
    "height" : 280.0,
    "maxFileSize" : -1
}, {
    "id" : 12,
    "name" : "180x150 (Rectangle)",
    "label" : "AdSize.180x150 (Rectangle).label",
    "longLabel" : "AdSize.180x150 (Rectangle).longLabel.label",
    "title" : "AdSize.180x150 (Rectangle).title.label",
    "width" : 180.0,
    "height" : 150.0,
    "maxFileSize" : -1
}, {
    "id" : 13,
    "name" : "300x100 (3:1 Rectangle)",
    "label" : "AdSize.300x100 (3:1 Rectangle).label",
    "longLabel" : "AdSize.300x100 (3:1 Rectangle).longLabel.label",
    "title" : "AdSize.300x100 (3:1 Rectangle).title.label",
    "width" : 300.0,
    "height" : 100.0,
    "maxFileSize" : -1
}, {
    "id" : 14,
    "name" : "720x300 (Pop-Under)",
    "label" : "AdSize.720x300 (Pop-Under).label",
    "longLabel" : "AdSize.720x300 (Pop-Under).longLabel.label",
    "title" : "AdSize.720x300 (Pop-Under).title.label",
    "width" : 720.0,
    "height" : 300.0,
    "maxFileSize" : -1
}, {
    "id" : 15,
    "name" : "468x60  (Full Banner)",
    "label" : "AdSize.468x60  (Full Banner).label",
    "longLabel" : "AdSize.468x60  (Full Banner).longLabel.label",
    "title" : "AdSize.468x60  (Full Banner).title.label",
    "width" : 468.0,
    "height" : 60.0,
    "maxFileSize" : -1
}, {
    "id" : 16,
    "name" : "234x60  (Half-Banner)",
    "label" : "AdSize.234x60  (Half-Banner).label",
    "longLabel" : "AdSize.234x60  (Half-Banner).longLabel.label",
    "title" : "AdSize.234x60  (Half-Banner).title.label",
    "width" : 234.0,
    "height" : 60.0,
    "maxFileSize" : -1
}, {
    "id" : 17,
    "name" : "88x31   (Micro Bar)",
    "label" : "AdSize.88x31   (Micro Bar).label",
    "longLabel" : "AdSize.88x31   (Micro Bar).longLabel.label",
    "title" : "AdSize.88x31   (Micro Bar).title.label",
    "width" : 88.0,
    "height" : 31.0,
    "maxFileSize" : -1
}, {
    "id" : 18,
    "name" : "120x90  (Button 1)",
    "label" : "AdSize.120x90  (Button 1).label",
    "longLabel" : "AdSize.120x90  (Button 1).longLabel.label",
    "title" : "AdSize.120x90  (Button 1).title.label",
    "width" : 120.0,
    "height" : 90.0,
    "maxFileSize" : -1
}, {
    "id" : 19,
    "name" : "120x60  (Button 2)",
    "label" : "AdSize.120x60  (Button 2).label",
    "longLabel" : "AdSize.120x60  (Button 2).longLabel.label",
    "title" : "AdSize.120x60  (Button 2).title.label",
    "width" : 120.0,
    "height" : 60.0,
    "maxFileSize" : -1
}, {
    "id" : 20,
    "name" : "120x240 (Vertical Banner)",
    "label" : "AdSize.120x240 (Vertical Banner).label",
    "longLabel" : "AdSize.120x240 (Vertical Banner).longLabel.label",
    "title" : "AdSize.120x240 (Vertical Banner).title.label",
    "width" : 120.0,
    "height" : 240.0,
    "maxFileSize" : -1
}, {
    "id" : 21,
    "name" : "125x125 (Square Button)",
    "label" : "AdSize.125x125 (Square Button).label",
    "longLabel" : "AdSize.125x125 (Square Button).longLabel.label",
    "title" : "AdSize.125x125 (Square Button).title.label",
    "width" : 125.0,
    "height" : 125.0,
    "maxFileSize" : -1
}, {
    "id" : 22,
    "name" : "728x90  (Leaderboard)",
    "label" : "AdSize.728x90  (Leaderboard).label",
    "longLabel" : "AdSize.728x90  (Leaderboard).longLabel.label",
    "title" : "AdSize.728x90  (Leaderboard).title.label",
    "width" : 728.0,
    "height" : 90.0,
    "maxFileSize" : -1
}, {
    "id" : 23,
    "name" : "160x900 (Wide Skyscraper)",
    "label" : "AdSize.160x900 (Wide Skyscraper).label",
    "longLabel" : "AdSize.160x900 (Wide Skyscraper).longLabel.label",
    "title" : "AdSize.160x900 (Wide Skyscraper).title.label",
    "width" : 160.0,
    "height" : 900.0,
    "maxFileSize" : -1
}, {
    "id" : 24,
    "name" : "120x600 (Skyscraper)",
    "label" : "AdSize.120x600 (Skyscraper).label",
    "longLabel" : "AdSize.120x600 (Skyscraper).longLabel.label",
    "title" : "AdSize.120x600 (Skyscraper).title.label",
    "width" : 120.0,
    "height" : 600.0,
    "maxFileSize" : -1
}, {
    "id" : 25,
    "name" : "300x600 (Half Page Ad)",
    "label" : "AdSize.300x600 (Half Page Ad.label",
    "longLabel" : "AdSize.300x600 (Half Page Ad.longLabel.label",
    "title" : "AdSize.300x600 (Half Page Ad.title.label",
    "width" : 300.0,
    "height" : 600.0,
    "maxFileSize" : -1
},

    // new sizes not in AOD yet
    {
        "id" : 27,
        "name" : "Billboard",
        "width" : 970,
        "height" : 250
    }, {
        "id" : 28,
        "name" : "Smartphone Banner",
        "width" : 300,
        "height" : 50
    },{
        "id" : 29,
        "name" : "Smartphone Banner Wide",
        "width" : 320,
        "height" : 50
    },{
        "id" : 30,
        "name" : "Super Leaderboard/ Pushdown",
        "width" : 970,
        "height" : 90
    },{
        "id" : 31,
        "name" : "Portrait",
        "width" : 300,
        "height" : 1050
    },{
        "id" : 33,
        "name" : "Mobile Phone Interstitial Small",
        "width" : 640,
        "height" : 1136
    },{
        "id" : 34,
        "name" : "Mobile Phone Interstitial Medium",
        "width" : 750,
        "height" : 1334
    },{
        "id" : 35,
        "name" : "Mobile Phone Interstitial Large",
        "width" : 1080,
        "height" : 1920
    },{
        "id" : 36,
        "name" : "Feature Phone Small Banner",
        "width" : 120,
        "height" : 20
    },{
        "id" : 37,
        "name" : "Feature Phone Medium Banner",
        "width" : 168,
        "height" : 28
    },{
        "id" : 38,
        "name" : "Feature Phone Large Banner",
        "width" : 216,
        "height" : 36
    }


];

// will return first match,  can be used with just height or width
// return full AOD adSize object
export function getWebAdSizeByDims(dims) {
    const where = pick(dims, 'width', 'height');

    if ('width' in where || 'height' in where){
        return find(webAdSizes, where);
    }
}


export function getWebAdSizeByName(name) {
    return find(webAdSizes, {name});
}